<template>
  <v-dialog v-model="modalStatus" scrollable persistent>
    <v-card>
      <v-card-text>
        <iframe :src="url" width="100%" style="height: 90vh"></iframe>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" dark @click="closeModal">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["openModal", "measure"],
  data() {
    return {
      modalStatus: this.openModal,
      url: this.measure,
    };
  },
  methods: {
    closeModal() {
      this.url = null;
      this.modalStatus = false;
      this.$emit("close-modal");
    },
  },
};
</script>